import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

const scrollbarStyle = {
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#94a3b8 #e2e8f0',
};

const webkitScrollbarStyle = {
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#e2e8f0',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#94a3b8',
        borderRadius: '4px',
    }
};

function PropReason({ sportcode, showReason, toggleShowReason, param }) {
    return (param && param.playerId > 0) ? (
        <Modal size="lg" show={showReason} onHide={toggleShowReason}>
            <Modal.Body className="max-h-[90vh] overflow-y-auto" style={{ ...scrollbarStyle, ...webkitScrollbarStyle }}>
                <>
                    <div className="bg-gradient-to-r from-[#a1c4fd] to-[#c2e9fb] rounded-lg relative">
                        <button
                            onClick={toggleShowReason}
                            className="absolute right-2 top-2 bg-red-500 hover:bg-red-600 w-8 h-8 rounded-full text-white"
                        >
                            ×
                        </button>
                        <div className="min-h-0">
                            <div className="flex flex-col lg:flex-row h-auto">
                                
                                <div className="lg:w-1/3 h-auto">
                                    <div className="flex justify-center items-center lg:order-none order-1 p-2">
                                        <picture>
                                            <source src={`https://myinsideedge.com/sportsdataio/${sportcode}_sm/playerid_${param.sdplayerid}.webp`} type="image/webp" />
                                            <img
                                                className="object-contain h-[100px] lg:h-[120px] z-10"
                                                src={`https://myinsideedge.com/sportsdataio/${sportcode}_sm/playerid_${param.sdplayerid}.png`}
                                                alt="Alternate Text"
                                            />
                                        </picture>
                                    </div>
                                </div>

                                
                                <div className="lg:w-2/3">
                                    <div className="text-center whitespace-nowrap">
                                        <div className="flex justify-center">
                                            <ul className="w-full">
                                                <li className="text-white text-lg lg:text-xl font-bold uppercase mb-0 pb-0 px-2">
                                                    {param.playerName}
                                                </li>
                                                <li className="text-lg lg:text-xl font-bold uppercase p-0 capitalize bg-gradient-to-l from-[#a1c4fd] via-[#c2e9fb] to-[#a1c4fd]">
                                                    <div className="flex justify-around py-1">
                                                        <div className="w-[85%]">
                                                            <h5 className="font-bold m-0 text-base lg:text-lg">{param.propsUnit.OverUnder}</h5>
                                                            <span className="text-base">{param.propsUnit.PropVal} {param.pUnit}</span>
                                                            <h6 className="text-sm lg:text-base">{param.vsTeam ? `Vs. ${param.vsTeam}` : ''}</h6>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stats Card */}
                    <div className="bg-white rounded-lg shadow-sm mt-2">
                        <div className="max-h-[60vh] overflow-y-auto" style={{ ...scrollbarStyle, ...webkitScrollbarStyle }}>
                            <div className="w-full">
                                <div className="w-full">
                                    <table className="w-full border-collapse">
                                        <thead className="sticky top-0 bg-white shadow-sm">
                                            <tr>
                                                <th className="bg-gray-50 capitalize text-center font-normal border-0 p-2">
                                                    {[...Array(5)].map((_, i) => (
                                                        <span
                                                            key={i}
                                                            className={`material-icons text-xl ${param.propsUnit.ReasonAStars > i
                                                                    ? "text-red-500"
                                                                    : "text-red-200"
                                                                }`}
                                                        >
                                                            star_rate
                                                        </span>
                                                    ))}
                                                </th>
                                                <th className="bg-gray-50 capitalize text-center font-normal border-0 p-2">
                                                    {[...Array(5)].map((_, i) => (
                                                        <span
                                                            key={i}
                                                            className={`material-icons text-xl ${param.propsUnit.ReasonBStars > i
                                                                    ? "text-blue-500"
                                                                    : "text-blue-200"
                                                                }`}
                                                        >
                                                            star_rate
                                                        </span>
                                                    ))}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th className="text-red-500 bg-gray-50 uppercase text-base lg:text-lg text-center p-2">
                                                    {param.propsUnit.ReasonsA.length > 0 ? param.propsUnit.ReasonsA.length : ''} Reasons for over
                                                </th>
                                                <th className="text-blue-500 bg-gray-50 uppercase text-base lg:text-lg text-center p-2">
                                                    {param.propsUnit.ReasonsB.length > 0 ? param.propsUnit.ReasonsB.length : ''} Reasons for under
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="w-1/2 align-top">
                                                    <ul className="divide-y">
                                                        {param.propsUnit.ReasonsA.map((i, index) => (
                                                            <li key={index} className="flex items-start p-3 text-sm lg:text-base">
                                                                <div className="ml-2 mr-auto">{i}</div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </td>
                                                <td className="w-1/2 align-top">
                                                    <ul className="divide-y">
                                                        {param.propsUnit.ReasonsB.map((i, index) => (
                                                            <li key={index} className="flex items-start p-3 text-sm lg:text-base">
                                                                <div className="ml-2 mr-auto">{i}</div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </Modal.Body>
        </Modal>
    ) : (
        <></>
    );
}

export default PropReason;